export const FUNNEL_STEP_NUMBER_MAP = {
  itinerary: 1,
  flight: 2,
  accommodation: 3,
  excursions: 4,
  transport: 5,
  extras: 6,
  summary: 7,
  book: 8,
  travellers: 9,
  checkout_extras: 10,
  payment: 11,
} as const
